import React, { Fragment } from 'react';

import Tooltip from 'CommonComponents/Tooltip';

import CircleInfoIcon from 'Assets/icons/circle-info.svg';

export default function ContentListItem({ title, content, info, children, classNames = '' }) {
    return (
        <Fragment>
            <li className={`tw-flex max-lg:tw-flex-col ${classNames}`}>
                <span className="tw-w-7/12 max-lg:tw-w-full tw-font-semibold">
                    <div className="tw-flex tw-items-center tw-gap-x-2">
                        <div>{title}</div>
                        {info && (
                            <Tooltip placement="top-end" tooltipContent={info} tooltipType="text" backgroundClass="tw-bg-charcoal">
                                <div>
                                    <CircleInfoIcon className="tw-w-4 tw-h-4 tw-text-blue" />
                                </div>
                            </Tooltip>
                        )}
                    </div>
                </span>
                <span className="tw-w-5/12 max-lg:tw-w-full">{children ? children : content}</span>
            </li>
        </Fragment>
    );
}
